import styled from 'styled-components';

export const TopBarStyled = styled.div`
  width: 100%;
  color: ${(props) => props?.theme?.text?.darkest};
  background: ${(props) => props?.theme?.blue?.midBlue};
  padding: 10px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1101;
  transition: top 0.3s ease;

  .container {
    max-width: 1300px;
  }

  &.fixed {
    top: -45px;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    gap: 8px;

    li {
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 5px;

      .app-link {
        display: flex;
        margin: 0 8px 0 0;
      }

      .ic {
        width: 13px;
        height: 13px;
        display: flex;

        img {
          width: 100%;
          max-width: 100%;
          height: 100%;
          display: flex;
          path {
            filter: none;
          }
        }
      }
      .label {
        font-size: 14px;
        font-weight: 400;
      }
    }
    &.rightSection {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin: 0px;
      gap: 16px;

      li {
        .phone {
          gap: 8px;
          .ic {
            margin: 0px;
          }
        }
      }
    }
  }
  .a {
    text-decoration: none;
  }
  .phone {
    color: ${(props) => props.theme.text.darkest};
    text-decoration: none;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    direction: ltr;

    .text {
      font-size: 13px;
    }

    .ic {
      width: 13px;
      height: 13px;
      margin: 0 5px 0 0;
      display: flex;

      svg {
        width: 100%;
        height: 100%;
        display: flex;

        path {
          filter: none;
        }
      }

      img {
        max-width: 100%;
      }
    }
  }
  @media (max-width: 1200px) {
    .leftSection {
      li:first-child {
        display: none;
      }
    }
  }
  @media (max-width: 991px) {
    .leftSection {
      display: none;
    }
  }
  @media (max-width: 767px) {
    .no-content {
      display: none;
    }
    &.hide-mobile {
      display: none;
    }
  }
  @media (max-width: 480px) {
  }
`;
